
import { DocumentCellRendererComponent } from "src/app/components/crm/companies/pages/company-info-tabs/document-cell-renderer/document-cell-renderer.component";
import { AgColDefsI, AgGridI,} from "../../../../shared/components/ag-grid/ag-grid.model";
import { AgDropdownCorrectFieldComponent } from "src/app/shared/components/ag-dropdown-correct-field/ag-dropdown-correct-field.component";
import { GridName } from "../../../../shared/model/ag-grid-common-constant";
import { COMPANY_REQUIRED_VALUES, CROSSWALK_REQUIRED_VALUES, BOM_REQUIRED_FIELDS, VENDOR_REQUIRED_VALUES } from "../../import-documents.model";



const SystemsColumn: AgColDefsI = {
  headerName: "System Columns",
  field: "systemColumn",
  minWidth: 150, 
  maxWidth: 600,
  flex: 1,  
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellStyle:{ 
    'color':'var(--sitewide_primary_accent_color)',
    'padding-left':' 20px'
  },
  cellRenderer: params => {
    const cellValue = params.value;
   // const rowIndex = params.rowIndex;
    if (CROSSWALK_REQUIRED_VALUES.includes(cellValue)) {
      const htmlContent = `<i class="fst-normal ps-1 p-0 text-danger">*</i>`;
      return `${cellValue}${htmlContent}`;
    } else {
      return cellValue;
    }
  },
  //flex:1
};

const SystemColumn: AgColDefsI = {
  headerName: "System Columns",
  field: "systemColumn",
  minWidth: 100,
  width:400,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellStyle:{ 
    'color':'var(--sitewide_primary_accent_color)',
    'padding-left':' 20px'
  },
  cellRenderer: params => {
    const cellValue = params.value;
   // const rowIndex = params.rowIndex;
    if (COMPANY_REQUIRED_VALUES.includes(cellValue)) {
      const htmlContent = `<i class="fst-normal ps-1 p-0 text-danger">*</i>`;
      return `${cellValue}${htmlContent}`;
    } else {
      return cellValue;
    }
  },
  //flex:1
};
const SystemMapColumn: AgColDefsI = {
  headerName: "System Columns",
  field: "systemColumn",
  minWidth: 100,
  width:400,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellStyle:{ 
    'color':'var(--sitewide_primary_accent_color)',
    'padding-left':' 20px'
  },
  cellRenderer: params => {
    const cellValue = params.value;
    if (params?.data?.requiredField?.includes(cellValue)) {
      const htmlContent = `<i class="fst-normal ps-1 p-0 text-danger">*</i>`;
      return `${cellValue}${htmlContent}`;
    }else if (params?.data?.isRequired) {
      const htmlContent = `<i class="fst-normal ps-1 p-0 text-danger">*</i>`;
      return `${cellValue}${htmlContent}`;
    }else {
      return cellValue;
    }
  },
};

const SystemVendorColumn: AgColDefsI = {
  headerName: "System Columns",
  field: "systemColumn",
  minWidth: 100,
  width:400,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellStyle:{ 
    'color':'var(--sitewide_primary_accent_color)',
    'padding-left':' 20px'
  },
  cellRenderer: params => {
    const cellValue = params.value;
   // const rowIndex = params.rowIndex;
    if (VENDOR_REQUIRED_VALUES.includes(cellValue)) {
      const htmlContent = `<i class="fst-normal ps-1 p-0 text-danger">*</i>`;
      return `${cellValue}${htmlContent}`;
    } else {
      return cellValue;
    }
  },
  //flex:1
};

const MapColumn: AgColDefsI = {
  headerName: "Map to",
  field: "mappedColumn",
  minWidth: 250,
  maxWidth: 600,
  flex: 1,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellRenderer: AgDropdownCorrectFieldComponent,
  cellRendererParams:{count:true}
 // flex:1,
};
const CommonMapColumn: AgColDefsI = {
  headerName: "Map to",
  field: "mappedColumn",
  minWidth: 200,
  width:470,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellRenderer: AgDropdownCorrectFieldComponent,
  cellRendererParams: { count: true }
};
const CommonStatusColumn: AgColDefsI = {
  headerName: "Status",
  field: "status",
  minWidth: 100,
  width:250,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellRenderer: DocumentCellRendererComponent,
  flex:1
};


const StatusColumn: AgColDefsI = {
  headerName: "Status",
  field: "status",
  minWidth: 100,
  width:250,
  editable: false,
  sortable: true,
  suppressMovable: false,
  // cellStyle:{
  //   'display':'flex',
  //   'justify-content':'center',
  // },
  cellRenderer: DocumentCellRendererComponent,
  flex:1
};

const SystemMapBOMColumn: AgColDefsI = {
  headerName: "System Columns",
  field: "systemColumn",
  minWidth: 100,
  width:400,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellStyle:{ 
    'color':'var(--sitewide_primary_accent_color)',
    'padding-left':' 20px'
  },
  cellRenderer: params => {
    const cellValue = params.value;
    if (BOM_REQUIRED_FIELDS.includes(cellValue)) {
      const htmlContent = `<i class="fst-normal ps-1 p-0 text-danger">*</i>`;
      return `${cellValue}${htmlContent}`;
    } else {
      return cellValue;
    }
  },
};

const MapBOMColumn: AgColDefsI = {
  headerName: "Map to",
  field: "mappedColumn",
  minWidth: 250,
  maxWidth: 600,
  flex: 1,
  editable: false,
  sortable: true,
  suppressMovable: false,
  cellRenderer: AgDropdownCorrectFieldComponent,
  cellRendererParams:{count:true}
};

export const ColDefsDocuments: AgColDefsI[] = [
   SystemColumn,
   MapColumn,
   StatusColumn,
 ];
 export const ColDefsDocumentsAnother: AgColDefsI[] = [
  SystemsColumn,
  MapColumn,
  StatusColumn,
];
export const ColDefsCommonMap: AgColDefsI[] = [
  SystemMapColumn,
  CommonMapColumn,
  CommonStatusColumn,
];

export const ColDefsVendorDocuments: AgColDefsI[] = [
  SystemVendorColumn,
  MapColumn,
  StatusColumn,
];

export const ColDefsBOMDocuments: AgColDefsI[] = [
  SystemMapBOMColumn,
  MapBOMColumn,
  StatusColumn,
];

export const AgGridImportVendorMap: AgGridI = {
  colDefs: ColDefsVendorDocuments,
  rowSelection: "multiple",
};

export const AgGridImportCompaniesMap: AgGridI = {
  colDefs: ColDefsDocuments,
  rowSelection: "multiple",
};
export const AgGridImportCodecrosswalkMap: AgGridI = {
  colDefs: ColDefsDocumentsAnother,
  rowSelection: "multiple",
};

export const AgGridImportCommonMap: AgGridI = {
  colDefs: ColDefsCommonMap,
  rowSelection: "multiple",
};

export const AgGridImportBOMMap: AgGridI = {
  colDefs: ColDefsBOMDocuments,
  rowSelection: "multiple",
};

const ipadMediaQuery = window.matchMedia("(min-width: 767px) and (max-width: 1025px)");
if (ipadMediaQuery.matches) {
  // SystemColumn.width = 300; // Set width for iPad screens
  SystemMapColumn.flex = 1;
  CommonMapColumn.flex = 2;
  CommonStatusColumn.flex = 1;
   SystemColumn.flex = 1;
   MapColumn.flex = 2;
   StatusColumn.flex = 1;
  SystemMapBOMColumn.flex = 1;
  MapBOMColumn.flex = 2;
}

